import { Description } from './SurveyStepOptionsCta.styled';

export default function SurveyStepOptionsCta({
  options,
  description,
  children,
}) {
  return children({
    disabled: false,
    answers: options,
    content: (
      <Description variant="grey-14-demibold" color="black">
        {description}
      </Description>
    ),
  });
}
